import { render, staticRenderFns } from "./editProperty.vue?vue&type=template&id=52b875ee&scoped=true&"
import script from "./editProperty.vue?vue&type=script&lang=js&"
export * from "./editProperty.vue?vue&type=script&lang=js&"
import style0 from "./editProperty.vue?vue&type=style&index=0&id=52b875ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b875ee",
  null
  
)

export default component.exports